import { Localized } from "@fluent/react/compat";
import React, { FunctionComponent } from "react";

import { TodayOIDCUserCreationMetricsJSON } from "coral-common/common/lib/types/dashboard";
import { useImmediateFetch } from "coral-framework/lib/relay/fetch";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "coral-ui/components/v2";

import { DashboardBox, DashboardComponentHeading, Loader } from "../components";
import createDashboardFetch from "../createDashboardFetch";

const TodayOIDCUserCreationsMetrics = createDashboardFetch<TodayOIDCUserCreationMetricsJSON>(
  "oidcUsersMetricsHandler",
  "/dashboard/today/oidc/users"
);

interface Props {
  siteID: string;
  lastUpdated: string;
}

const TodayOIDCUserCreations: FunctionComponent<Props> = ({ siteID, lastUpdated }) => {
  const [today, loading] = useImmediateFetch(
    TodayOIDCUserCreationsMetrics,
    { siteID },
    lastUpdated
  );

  return (
    <DashboardBox>
      <Localized id="dashboard-today-oidc-users-heading">
        <DashboardComponentHeading>
          OIDC user creations
        </DashboardComponentHeading>
      </Localized>
      <Table fullWidth>
        <TableHead>
          <TableRow>
            <Localized id="dashboard-today-oidc-users-table-header-date">
              <TableCell>Date</TableCell>
            </Localized>
            <Localized id="dashboard-today-oidc-users-table-header-creations">
              <TableCell align="end">Creations</TableCell>
            </Localized>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading && (
            <TableRow>
              <TableCell colSpan={2}>
                <Loader loading={loading} />
              </TableCell>
            </TableRow>
          )}
          {today && today.series && today.series.length < 1 && (
            <TableRow>
              <Localized id="dashboard-today-oidc-users-no-creations">
                <TableCell colSpan={2}>No OIDC user creations today.</TableCell>
              </Localized>
            </TableRow>
          )}
          {today &&
            today.series?.map((serie) => (
              <TableRow key={`oidc-users-${serie.timestamp}`}>
                <TableCell>
                    {new Date(serie.timestamp).toLocaleDateString()}
                </TableCell>
                <TableCell align="end">{serie.count}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </DashboardBox>
  );
};

export default TodayOIDCUserCreations;
